import React from "react";
import Table from "../CommonTable";
import { useMediaQuery } from "react-responsive";
import { CONSTANTS } from "../../shared/constants";
import { store } from "../../redux/store";
import { setIsGlobalModalOpen, setModalData } from "../../redux/modal";
import { Favourite, Info, NotFavourite } from "../../icons";
import moment from "moment";

const ProcessCard = ({ record, card }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div className="process-card">
      {record && (
        <div>
          <Table rows={[record]} isMobile={isMobile} />
          <BidInfo record={record} />
        </div>
      )}
      {card && (
        <div>
          <Card cards={card} />
          <BidInfo record={card} />
        </div>
      )}
    </div>
  );
};

const BidInfo = ({ record }) => {
  const [value, setValue] = React.useState(record.currentPrice);
  const handleIncrement = () => {
    setValue((prevValue) => prevValue + 1000);
  };

  const handleDecrement = () => {
    setValue((prevValue) => prevValue - 1000);
  };

  return (
    <div className="bid-info" style={{ alignItems: "center" }}>
      <div className="prices">
        <div>
          <span className="bidInfoDetails">Offer Price：</span>
          <span className="bidInfoDetailPrice">
            {record.vehicle.discountPrice.toLocaleString()} Yen{" "}
          </span>
        </div>
        <div>
          <span className="bidInfoDetails">Total Price：</span>
          <span className="bidInfoDetailPrice">
            {record.totalPrice.toLocaleString()} Yen{" "}
          </span>
        </div>
      </div>
      <div className="others">
        <Counter
          value={value}
          handleDecrement={handleDecrement}
          handleIncrement={handleIncrement}
          setValue={setValue}
        />

        <button
          className="bid-btn round"
          onClick={async () => {
            store.dispatch(setIsGlobalModalOpen(true));
            store.dispatch(
              setModalData({
                auctionType: CONSTANTS.AUCTION_TYPES.TENDER,
                currentPrice: value,
                vehicleId: record.vehicle._id,
              })
            );
          }}
        >
          <img src="hammer.png" alt="hammer.png" />
          Offer
        </button>
      </div>
    </div>
  );
};

const Counter = ({ value, setValue, handleDecrement, handleIncrement }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "center" : "auto",
        justifyContent: "space-between",
        marginTop: 40,
      }}
    >
      <div className="textcounter">
        <div className="textual">
          <h3>Bid Amount</h3>
          <span>Bid Unit Price (1000 Yen)</span>
        </div>
        <div className="counter">
          <div className="input-box">
            <input
              type="number"
              className="hide-arrows"
              value={value}
              onChange={(e) => setValue(parseInt(e.target.value))}
            />
            Yen
          </div>
          <div className="count-btns">
            <button onClick={handleIncrement}>
              <i className="fa fa-angle-up"></i>
            </button>
            <button onClick={handleDecrement}>
              <i className="fa fa-angle-down"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
const Card = ({ cards }) => {
  const getDate = (date) => {
    if (date) {
      const japanDateTime = moment(date).format("YYYY-MM-DD");

      return japanDateTime;
    }

    return "";
  };
  return (
    <div key={cards} className="mainCardslistSearch">
      <div className="containerSearchCardsPF">
        <div className="searchimagecontainerProcessedcard">
          <img
            className="search-Imglist"
            src={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
            alt={`${process.env.REACT_APP_BTC_API_URL}/${cards?.vehicle?.thumbnail}`}
          />
        </div>
        <div className="cardscontentcontainerP">
          <div className="contentSearchPF">
            <a
              style={{ marginTop: 8, fontSize: 11, fontWeight: 800 }}
              href="#auctionno"
            >
              No.{cards?.vehicle?.auctionNo}
            </a>

            <div className="damagedUsedContainer">
              {cards?.vehicle?.condition === "DAMAGE" && (
                <button className="damagedcard">
                  <span className="some_thing">Damaged</span>
                </button>
              )}
              {cards?.vehicle?.condition === "USED" && (
                <button className="usedcard">
                  <span className="some_thing">Used</span>
                </button>
              )}
              <div className="iconContainer">
                {cards?.vehicle?.isFavorite === true ? (
                  <Favourite style={{ width: 17, height: 17, marginTop: 1 }} />
                ) : (
                  <NotFavourite
                    style={{ width: 17, height: 17, marginTop: 1 }}
                  />
                )}
              </div>
            </div>
          </div>
          <div style={{ marginTop: -7 }}>
            <span className="cardNameSearch">{cards?.vehicle?.name}</span>
          </div>
          <div style={{ marginTop: -5 }}>
            <span
              style={{ color: "#dc0000", fontWeight: "bold", fontSize: 12 }}
            >
              {cards?.vehicle?.discountPrice.toLocaleString()} Yen
            </span>
          </div>
          <span style={{ display: "flex" }}>
            <b style={{ fontSize: 10, color: "black" }}>
              {cards?.vehicle?.auctionType ===
              CONSTANTS.AUCTION_TYPES.NEGOTIATION
                ? "NEGOTIATION"
                : `${cards?.vehicle?.auctionType} :`}
            </b>
            <span className="auctionendDate">
              {getDate(cards?.vehicle?.auctionEndDate)}
            </span>
          </span>
          <div style={{ display: "flex", marginTop: 2 }}>
            <b style={{ fontSize: 10 }}>Location : </b>
            <b className="currentAddressSearch">
              {" "}
              {cards?.vehicle?.currentAddress}{" "}
            </b>
            <Info className="infoIcon" />
          </div>
          <div>
            <p className="detailsofVehicle">
              {cards?.vehicle?.year} &nbsp; | &nbsp;&nbsp;
              {cards?.vehicle?.mileage?.toLocaleString()} km &nbsp;&nbsp;|
              &nbsp;&nbsp;
              {cards?.vehicle?.displacement?.toLocaleString()} cc &nbsp;&nbsp; |
              &nbsp;&nbsp;
              {cards?.vehicle?.fuel}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessCard;
